/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const deductPoint = params => {
  return axios.post(`${base}/deduct_point_${params.userid}`, params)
}
export const addPoint = params => {
  return axios.post(`${base}/add_point_${params.userid}`, params)
}



// WEBPACK FOOTER //
// ./src/views/point/point.api.js